import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BubbleShooterGameCoreService } from './bubble-shooter-game-core.service';
import { BubbleShooterGameSelectorComponent } from './bubble-shooter-game-selector/bubble-shooter-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [BubbleShooterGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [BubbleShooterGameCoreService],
  exports: [BubbleShooterGameSelectorComponent],
})
export class BubbleShooterGameCoreModule {}
